import { styled } from '@mui/material';
import { FC } from 'react';
import { Flex, FlexProps } from '@/components';

export const PageContainer = styled(Flex as FC<FlexProps>)(() => ({
	width: '100%',
	height: '100%',
	backgroundColor: 'transparent',
	flexDirection: 'column',
	overflowY: 'auto',
	padding: '8px'
}));
